import { TierRate } from '../../interfaces';

export class Tier {

  percentage: number;
  base: number;
  offset: number;

  constructor(data: TierRate) {
    this.percentage = ( data.percentage || 0 ) / 100;
    this.base = data.base || 0;
    this.offset = data.offset || 0;
  }

  tax(amount: number) {    
    if (amount <= 0) {
      return 0;
    }
    
    return this.base + this.percentage * ( amount + this.offset );
  }

}
